import * as React from "react";
import * as ReactDOM from "react-dom";
import Commonnav from "@/layouts/commonnav/commonnav";
import ZeusCommonTools from "@/widgets/zeus_common_tools";
import ZeusCommonToolsData from "./data/zeus_common_tools/data";

class Home extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Commonnav>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_common_tools" data-version="1.0.13">
                <ZeusCommonTools {...ZeusCommonToolsData} />
              </div>
            </div>
          </div>
        </div>
      </Commonnav>
    );
  }
}

ReactDOM.render(<Home />, document.getElementById("root"));
